import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { SortOptions, SortType } from '../../enums/SORT';

export const getCollaborativeFolders = async (query: {
  page: number;
  limit: number;
  total: number;
  sort: SortType;
  sortField: SortOptions;
  search: string;
}) => {
  const { page, limit, total, sort, sortField, search } = query;
  return await axiosInstance.get(
    `${API_ROUTES.COLLABORATIVE_FOLDER}?page=${
      page + 1
    }&limit=${limit}&total=${total}&sort=${sort}&sortField=${sortField}&search=${search}`,
  );
};

export const getCollaborativeFoldersForParent = async (query: {
  page: number;
  limit: number;
  total: number;
  sort: SortType;
  sortField: SortOptions;
  search: string;
}) => {
  const { page, limit, total, sort, sortField, search } = query;
  return await axiosInstance.get(
    `${API_ROUTES.COLLABORATIVE_FOLDER_FOR_PARENT}?page=${
      page + 1
    }&limit=${limit}&total=${total}&sort=${sort}&sortField=${sortField}&search=${search}`,
  );
};

export const getCollaborativeFolderById = async (id: number) => {
  return await axiosInstance.get(`${API_ROUTES.COLLABORATIVE_FOLDER}/${id}`);
};
